import Vue from 'vue'
import Router from 'vue-router'
import Hello from '@/components/Hello'
import Disconnect from '@/components/Disconnect'
import Home from '@/components/Home'
import CreerUnMessage from '@/components/CreerUnMessage'
import GererDiffusion from '@/components/GererDiffusion'
import Confirmation from '@/components/Confirmation'
import MentionsLegales from '@/components/MentionsLegales'
import ConditionsUtilisation from '@/components/ConditionsUtilisation'
import ConseilsPratiques from '@/components/ConseilsPratiques'
import NotFoundComponent from '@/components/NotFoundComponent'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Hello',
      component: Hello
    },
    {
      path: '/disconnect',
      name: 'Disconnect',
      component: Disconnect
    },
    {
      path: '/app/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/app/creer-un-message',
      name: 'CreerUnMessage',
      component: CreerUnMessage
    },
    {
      path: '/app/gerer-diffusion',
      name: 'GererDiffusion',
      component: GererDiffusion
    },
    {
      path: '/app/confirmation',
      name: 'Confirmation',
      component: Confirmation
    },
    {
      path: '/miscellanous/mentions-legales',
      name: 'MentionsLegales',
      component: MentionsLegales
    },
    {
      path: '/miscellanous/conditions-utilisation',
      name: 'ConditionsUtilisation',
      component: ConditionsUtilisation
    },
    {
      path: '/miscellanous/conseils-pratiques',
      name: 'ConseilsPratiques',
      component: ConseilsPratiques
    },
    {
      path: '*',
      name: 'NotFoundComponent',
      component: NotFoundComponent
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js